import { createContext } from 'react'

import { OutlineReq } from 'packages/sdks-next/growp'
import { AnyType } from 'packages/types'

export const EditCourseTaskContext = createContext<{
  activityId: number
  outlines: OutlineReq[]
  curTaskId: number | undefined
  setCurTaskId: (taskId: number | undefined) => void
  createIt: ({
    outlines,
  }: {
    outlines?: OutlineReq[] | undefined
  }) => Promise<void>
}>(null as AnyType)
